import { IconButton } from "@wix/design-system";
import { ChevronLeftLarge } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { EditorContext, RicosContext } from "./../../ricos-context";
import { RICOS_LINE_SPACING_TYPE } from "./../../wix-rich-content-common";
import { FloatingLayout, FooterActions } from "./../../ui-components";
import { MODAL_ROOT } from "../data-hooks";
import { CustomSpacingEditor } from "./custom-spacing-editor";
import { useCurrentSpacing } from "./get-current-selection";
import classes from "./insert-decoration-modal-scss";
import { SpacingSelector } from "./spacing-selector/spacing-selector";
import { SpacingSelectorFooter } from "./spacing-selector/spacing-selector-footer";
const InsertDecorationModal = ({ closeModal }) => {
  const { getEditorCommands } = useContext(EditorContext);
  const { t, isMobile } = useContext(RicosContext);
  const editorCommands = getEditorCommands();
  const lineSpacing = useCurrentSpacing();
  const [initialLineSpacing] = useState(lineSpacing);
  const [isSpacingEditorOpen, setIsSpacingEditorOpen] = useState(false);
  const [customLineSpacing, setCustomLineSpacing] = useState(
    () => toCustomLineSpacing(initialLineSpacing)
  );
  const insertDecoration = (data, options = {}) => {
    editorCommands.insertDecoration(
      RICOS_LINE_SPACING_TYPE,
      {
        data
      },
      options
    );
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      dataHook: MODAL_ROOT,
      sidePanelProps: { width: isMobile ? "100%" : "fit-content", className: classes.panelRoot },
      onCloseButtonClick: () => {
        insertDecoration(initialLineSpacing, { shouldFocus: true });
      },
      header: isMobile ? {
        prefix: isSpacingEditorOpen ? /* @__PURE__ */ React.createElement(
          IconButton,
          {
            skin: "dark",
            priority: "secondary",
            className: classes.backButton,
            size: "small",
            onClick: () => setIsSpacingEditorOpen(false)
          },
          /* @__PURE__ */ React.createElement(ChevronLeftLarge, null)
        ) : null,
        title: isSpacingEditorOpen ? t("LineSpacing_customSpacing") : t("LineSpacing_lineSpacing"),
        showDivider: true
      } : void 0,
      content: {
        noPadding: true,
        children: isSpacingEditorOpen ? /* @__PURE__ */ React.createElement(
          CustomSpacingEditor,
          {
            lineSpacing: customLineSpacing,
            setLineSpacing: setCustomLineSpacing
          }
        ) : /* @__PURE__ */ React.createElement(
          SpacingSelector,
          {
            lineSpacing,
            initialLineSpacing,
            onSelectSpacing: insertDecoration
          }
        )
      },
      footer: {
        className: classes.footer,
        children: isSpacingEditorOpen ? /* @__PURE__ */ React.createElement(
          FooterActions,
          {
            onCancel: closeModal,
            onSave: () => {
              insertDecoration(toLineSpacingDecoration(customLineSpacing));
            }
          }
        ) : /* @__PURE__ */ React.createElement(SpacingSelectorFooter, { onOpenCustomEditor: () => setIsSpacingEditorOpen(true) })
      }
    }
  );
};
const toLineSpacingDecoration = (data) => {
  return {
    "line-height": data["line-height"],
    "padding-bottom": `${data["padding-bottom"]}px`,
    "padding-top": `${data["padding-top"]}px`
  };
};
const toCustomLineSpacing = (data) => ({
  "line-height": data["line-height"] ?? "1.5",
  "padding-bottom": data["padding-bottom"].slice(0, -2) ?? "0",
  "padding-top": data["padding-top"].slice(0, -2) ?? "0"
});
export {
  InsertDecorationModal
};
//# sourceMappingURL=insert-decoration-modal.js.map
